import log from '~/utils/log';

export default defineNuxtRouteMiddleware((to) => {
    const { $subSectionRegistry } = useNuxtApp();

    if (!isValidAcademyTrainingPath($subSectionRegistry.value, to.path, useCountryLanguages())) {
        log.debug(`[validate-academy-training-path] Aborting navigation for invalid path: ${to.path}`);
        return abortNavigation(createError({ statusCode: 404, statusMessage: 'Academy training section not found' }));
    }
});
